'use client';

import ArticleDetail from '@/components/article-detail';
import { BlogBreadcrumbItems } from '@/data/globals.data';

export default function Client() {
  return (
    <ArticleDetail breadcrumbItems={BlogBreadcrumbItems} showStoryBanner />
  );
}
